import React from 'react';

const NewsTwo = () => {
  return (
    <section className="blog-two" id="blog">
      <div className="container">
        <div className="section-title text-center">
          <div className="section-title__tagline-box">
            <span className="section-title__tagline">Latest Happenings</span>
            <div className="section-title-shape">
              <img src="assets/images/shapes/section-title-shape.png" alt="decorative shape" />
            </div>
          </div>
          <h2 className="section-title__title">Community Updates</h2>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="blog-two__single">
              <div className="blog-two__content">
                <h3 className="blog-two__title">
                  <a href="#!">Stay tuned for exciting news and updates from the Create & Commune community!</a>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsTwo;
